import type { FormerieClient } from "./client.js";
import type {
  PublicFormSchemaResult,
  SubmitPayload,
  SubmitRequestOptions,
  SubmitResponse,
  ValidatePayload,
  ValidateResponse,
} from "./types.js";

export interface WorkspaceFormerieTarget {
  workspace: string;
  form: string;
  branded?: false;
}

export type CanonicalFormerieTarget = WorkspaceFormerieTarget;

export interface BrandedFormerieTarget {
  form: string;
  branded: true;
}

export type FormerieTarget = CanonicalFormerieTarget | BrandedFormerieTarget;

export function isBrandedFormerieTarget(target: FormerieTarget): target is BrandedFormerieTarget {
  return target.branded === true;
}

export function submitFormerieTarget(
  client: FormerieClient,
  target: FormerieTarget,
  payload: SubmitPayload,
  options: SubmitRequestOptions = {},
): Promise<SubmitResponse> {
  if (isBrandedFormerieTarget(target)) {
    return client.submitBranded(target.form, payload, options);
  }

  return client.submit(target.workspace, target.form, payload, options);
}

export function validateFormerieTarget(
  client: FormerieClient,
  target: FormerieTarget,
  payload: ValidatePayload,
  options: SubmitRequestOptions = {},
): Promise<ValidateResponse> {
  if (isBrandedFormerieTarget(target)) {
    return client.validateBranded(target.form, payload, options);
  }

  return client.validate(target.workspace, target.form, payload, options);
}

export function schemaFormerieTarget(
  client: FormerieClient,
  target: FormerieTarget,
  options: SubmitRequestOptions = {},
): Promise<PublicFormSchemaResult> {
  if (isBrandedFormerieTarget(target)) {
    return client.schemaBranded(target.form, options);
  }

  return client.schema(target.workspace, target.form, options);
}
